/**
 * Simplified Chinese (CNY base) cross-currency transactions for the
 * multi-currency use case. Uses the real multi-currency accounts (定期存款 in
 * SGD, 美股組合 in USD) so the ¥/S$/$ mix and the cross-currency transfer
 * pair feel at home.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_CROSS_CURRENCY_TRANSACTIONS_ZH_CN = [
	{
		id: 'xcur-1',
		isTransferPair: true,
		date: '2026-08-05',
		type: 'Transfer',
		amount: 20000,
		description: '转入美股组合',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '储蓄',
		pairedType: 'Transfer',
		pairedAmount: 2778,
		pairedCurrencySymbol: '$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '美股组合',
		pairedAccountId: 'acc-joke',
		pairedDate: '2026-08-05',
	},
	{
		id: 'xcur-2',
		date: '2026-08-04',
		type: 'Deposit',
		amount: 35000,
		description: '工资',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '收入',
	},
	{
		id: 'xcur-3',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 86,
		description: '新加坡酒店',
		accountId: 'acc-savings',
		accountName: '定期存款',
		currency: 'SGD',
		currencySymbol: 'S$',
		currencyDecimalPlaces: 2,
		tagNames: '旅行',
	},
	{
		id: 'xcur-4',
		date: '2026-07-29',
		type: 'Purchase',
		amount: 45,
		description: '美区软件订阅',
		accountId: 'acc-joke',
		accountName: '美股组合',
		currency: 'USD',
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		tagNames: '工作',
	},
	{
		id: 'xcur-5',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 483,
		description: '超市',
		accountId: 'acc-credit',
		accountName: '返利卡',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '餐饮',
	},
];
